import React from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import { Field } from "formik";
import { get } from "object-path";

export default function({
  name,
  loading,
  options,
  map,
  onChange,
  onBlur,
  value
}) {
  return (
    <Field name={name}>
      {({ field, form, meta }) => {
        const fieldValue = map[field.value] || map[value];
        if (loading)
          return (
            <FormControl fullWidth margin="normal">
              <Autocomplete
                key="loading"
                loading={true}
                loadingText="Loading cities..."
                disabled={true}
                options={[]}
                renderInput={params => (
                  <TextField
                    {...params}
                    label="Loading cities..."
                    variant="outlined"
                    fullWidth
                  />
                )}
              />
            </FormControl>
          );
        return (
          <FormControl fullWidth margin="normal" error={Boolean(meta.error)}>
            <Autocomplete
              loading={loading}
              loadingText="Loading cities..."
              options={options}
              getOptionLabel={option => {
                return option.name;
              }}
              value={fieldValue}
              // style={{ width: 300 }}
              renderInput={params => (
                <TextField
                  {...params}
                  label="Select City"
                  variant="outlined"
                  fullWidth
                />
              )}
              onChange={(e, v) => {
                const result = form.setFieldValue(name, get(v, "id"));
                if (onChange) onChange(v);
                return result;
              }}
              onClose={field.onBlur}
            />
            {meta.error && <FormHelperText>{meta.error}</FormHelperText>}
          </FormControl>
        );
      }}
    </Field>
  );
}
